/* eslint-disable */
import axios from "../../common/cotAxios";
import {AddSurveyIF, UpdateSurveyIF} from "../../models/survey";

export default {
    // アンケート情報取得
    GetSurveyById(userId: number, videoId: number): Promise<any> {
        return axios.get("/api/getSurveyList", {params: {userId: userId, videoId: videoId}})
            .then(({data}) => data)
            .catch((error) => {return error;});
   },

    // アンケート回答登録
    AddSurveyAnswer(userId: number, videoId: number, surveyId: number, questionId: number, choiceId: number[]): Promise<void> {
        return axios.post("/api/addSurveyAnswer", {
            userId: userId,
            videoId: videoId,
            surveyId: surveyId,
            questionId: questionId,
            choiceIdList: choiceId.map((id) => {return {choiceId: id}})
       })
            .then(({data}) => data)
            .catch((error) => {return error});
   },

    // 全アンケート情報取得
    GetAllSurvey(): Promise<any> {
        return axios.get("/api/getAllSurveyList")
            .then(({data}) => data)
            .catch((error) => {return error;});
   },

    // アンケート新規追加
    AddSurvey(newSurvey: AddSurveyIF): Promise<any> {
        return axios.post("/api/addSurvey",newSurvey)
            .then(({data}) => data)
            .catch((error) => {return error;});
   },

    // アンケート更新
    UpdateSurvey(updateSurvey: UpdateSurveyIF): Promise<any> {
        return axios.post("/api/updateSurvey", updateSurvey)
            .then(({data}) => data)
            .catch((error) => {return error;});
   }
};
